/* istanbul ignore file */

import { Module } from 'vuex';
import { AppState } from '..';
import { Restaurant } from '@/models';
import { prefixValues } from '@/helpers/util';

export interface FindAChipotleModuleState {
  restaurantList: Restaurant[];
  hasGoogleMapsLoaded: boolean;
}

const MUTATION_NAMES = {
  SET_RESTAURANT_LIST: 'setRestaurantList',
  SET_HAS_GOOGLE_MAPS_LOADED: 'setHasGoogleMapsLoaded',
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'findAChipotle/');

export function makeFindAChipotleModule(): Module<FindAChipotleModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      restaurantList: [],
      hasGoogleMapsLoaded: false,
    },
    mutations: {
      [MUTATION_NAMES.SET_RESTAURANT_LIST]: (state, restaurants: Restaurant[]) => {
        state.restaurantList = restaurants;
      },
      [MUTATION_NAMES.SET_HAS_GOOGLE_MAPS_LOADED]: (state, mapsLoaded: boolean) => {
        state.hasGoogleMapsLoaded = mapsLoaded;
      }
    },
  };
}
